import { render, staticRenderFns } from "./DownloadSlideSection.vue?vue&type=template&id=88662306&scoped=true"
import script from "./DownloadSlideSection.vue?vue&type=script&lang=js"
export * from "./DownloadSlideSection.vue?vue&type=script&lang=js"
import style0 from "./DownloadSlideSection.vue?vue&type=style&index=0&id=88662306&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88662306",
  null
  
)

export default component.exports